
import FieldsetContainer from 'components/blocks/Delta/Inputs/Containers/FieldsetContainer';
import Province from 'components/blocks/Delta/Inputs/Province';
import TestCommunity from 'components/blocks/Delta/Inputs/TestCommunity';
import AccordionForm from 'components/blocks/ManagementNewForms/Accordion/AccordionForm';
import FormDatosPersonales from 'components/blocks/ManagementNewForms/ButtonGroups/FormDatosPersonales';
import FormInputFecha from 'components/blocks/ManagementNewForms/Inputs/FormInputFecha';
import FormBotonSubmit from 'components/blocks/ManagementNewForms/Inputs/FormInputSubmit';
import FormInputEmail from 'components/blocks/ManagementNewForms/Inputs/FormInputEmail';
import FormInputText from 'components/blocks/ManagementNewForms/Inputs/FormInputTexto';
import FormObservaciones from 'components/blocks/ManagementNewForms/Inputs/FormObservaciones';
import { useEffect, useRef, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form';
import FormInputTable, { fillArray } from 'components/blocks/ManagementNewForms/Inputs/FormInputTable';
import Loader from 'components/blocks/Loader/Loader';
import FormInputCheckboxTable from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputCheckBoxTable';
import InputRegimenFormularios from 'components/blocks/ManagementNewForms/Inputs/InputRegimenFormularios';
import FormInputRadioGroup from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputRadioGroup';
import AccordionDisplay from 'components/blocks/ManagementNewForms/Accordion/AccordionDisplay';
import FormInputCuentaBancaria from 'components/blocks/ManagementNewForms/Inputs/FormInputCuentaBancaria';
import FormArrayArchivosReducidos, { adaptDocumentacion, prepareDocumentacionArrayWithCase } from 'components/blocks/ManagementNewForms/ButtonGroups/ArrayInputArchivo';
import useCreateFormularioPECATA from 'services/record/FormularioPECATA/useCreateFormularioPECATA';
import useUpdateFormularioPECATAByID from 'services/record/FormularioPECATA/useUpdateFormularioPECATA';
import FormInfoCreateUpdate from 'components/blocks/ManagementNewForms/Inputs/FormInfoCreateUpdate';
import FormInputYesNo from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputYesNo';
import FormInfoSolicitudesDependientes from 'components/blocks/ManagementNewForms/Inputs/FormInfoSolicitudesDependientes';


const FormularioPECATA = ({ info, dataUser, onSuccess }: { info: boolean; dataUser: any, onSuccess?: () => void }) => {


    const formMethods = useForm();
    const { register, handleSubmit, setError, formState: { errors }, setValue, watch, reset, control, getValues } = formMethods;
    const { createFormularioPECATA, dataCreateFormularioPECATA, errorCreateFormularioPECATA, loadingCreateFormularioPECATA, successCreateFormularioPECATA } = useCreateFormularioPECATA();
    const { dataUpdateFormularioPECATAById, errorUpdateFormularioPECATAById, loadingUpdateFormularioPECATAById, successUpdateFormularioPECATAById, updateFormularioPECATAById } = useUpdateFormularioPECATAByID();
    const [datosAPI, setDatosAPI] = useState(dataUser);
    const [bloquearEnvio, setBloquearEnvio] = useState<boolean>(false);
    const [loader, setLoader] = useState(false);

    const [totalSize, setTotalSize] = useState(0);
    const MAX_SIZE_MB = 30;

    const watchProvinciaDatosActividad = watch("DatosActividad.EstablecimientoProvincia");
    const watchProvinciaDescDatosActividad = watch("DatosActividad.EstablecimientoProvinciaDescripcion");
    const watchCommDatosActividad = watch("DatosActividad.EstablecimientoLocalidad");
    const watchCommDescDatosActividad = watch("DatosActividad.EstablecimientoLocalidadDescripcion");

    const watchProvinciaCooperativa = watch("SocioCooperativa.CooperativaProvincia");
    const watchProvinciaDescCooperativa = watch("SocioCooperativa.CooperativaProvinciaDescripcion");
    const watchCommCooperativa = watch("SocioCooperativa.CooperativaLocalidad");
    const watchCommDescCooperativa = watch("SocioCooperativa.CooperativaLocalidadDescripcion");

    const watchProvinciaPluriactividad = watch("Pluriactividad.PluriactividadProvincia");
    const watchProvinciaDescPluriactividad = watch("Pluriactividad.PluriactividadProvinciaDescripcion");
    const watchCommPluriactividad = watch("Pluriactividad.PluriactividadLocalidad");
    const watchCommDescPluriactividad = watch("Pluriactividad.PluriactividadLocalidadDescripcion");

    const watchTipoCese = watch("CeseActividad.TipoCese");
    const watchSupuestosGenerales = watch("CeseActividad.SupuestosGenerales");
    const watchOtrosMotivosCeseTRADE = watch("CeseActividad.OtrosMotivosCeseTRADE");
    const watchOtrosMotivosCeseCooperativa = watch("CeseActividad.OtrosMotivosCeseCooperativa");
    const watchOtrosMotivosCeseAgrarios = watch("CeseActividad.OtrosMotivosCeseAgrarios");
    const watchArt305Sociedad = watch("CeseActividad.Art305Sociedad");

    const prevExclusiveMotivosRef = useRef({
        SupuestosGenerales: null,
        OtrosMotivosCeseTRADE: null,
        OtrosMotivosCeseCooperativa: null,
        OtrosMotivosCeseAgrarios: null,
        Art305Sociedad: null
    });

    const EmptyHijosACargo = {
        EstadoCivil: "",
        FechaNacimiento: null,
        HijoIPF: "",
        Incapacitado: null,
        NombreApellido: "",
        RentaAnoActual: null,
        RentaAnoAnterior: null,
        Trabajando: false

    };


    const adaptApiResponseToDefaultValues = (data: any) => {
        if (!data) return;
        reset({
            // =====================================================
            // DATOS AUTÓNOMO
            // =====================================================
            DatosAutonomo: {
                RegimenSS: data?.DatosPersonales_CodigoRegimen?.toString() || "0",

                TrabajadorAutonomo: {
                    ColaboradorAyudaFamiliar:
                        data?.DatosPersonales_AutonomoColaboradorAyudaFamiliar ?? false,
                    AdministradorConsejeroMercantil:
                        data?.DatosPersonales_AdministradorConsejeroSociedadMercantil ?? false,
                    SocioServiciosSociedadMercantil:
                        data?.DatosPersonales_SocioPrestaOtrosServiciosSociedadMercantil ?? false,
                    ComuneroSociosOtrasSociedades:
                        data?.DatosPersonales_ComuneroSocioOtrasSociedadesMercantiles ?? false,
                    EconomicamenteDependiente:
                        data?.DatosPersonales_AutonomoEconomicamenteDependiente ?? false,
                    CooperativaTrabajoAsociado:
                        data?.DatosPersonales_SocioCooperativaTrabajoAsociado ?? false,
                    AutonomoActividadProfesionalConjuntamente:
                        data?.DatosPersonales_AutonomoActividadProfesionalConjuntamente ?? false
                },
                SituacionSolicitante: {
                    EsProfesionalColegiado:
                        data?.DatosPersonales_ProfesionalColegiado ?? false,
                    PrestacionesAyudasParalizacionFlota:
                        data?.DatosPersonales_PerceptorPrestacionesAyudasParalizacionFlota ?? false,
                    OtrasPrestacionesSeguridadSocial:
                        data?.DatosPersonales_PerceptorOtrasPrestacionesSeguridadSocial ?? false,
                    PensionesSeguridadSocial:
                        data?.DatosPersonales_PerceptorPensionesSeguridadSocial ?? false,
                    TieneDeudasSeguridadSocial:
                        data?.DatosPersonales_TieneDeudasSeguridadSocial ?? false,
                    TieneAplazadasCuotasTesoreria:
                        data?.DatosPersonales_TieneAplazadasCuotasTesoreria ?? false
                },

                Tipo1: data?.DatosPersonales_Tipo1 || "",
                Tipo2: data?.DatosPersonales_Tipo2 || ""
            },

            // =====================================================
            // DATOS PERSONALES
            // =====================================================
            DatosPersonales: {
                SolicitanteIRPF:
                    data?.DatosPersonales_TipoIRPFVoluntario?.toString() || "",
                SolicitanteNumeroSS: data?.DatosPersonales?.NumeroSeguridadSocial || "",
                SolicitanteFechaNacimiento: data?.DatosPersonales_FechaNacimiento || "",
                SolicitanteNombre:
                    data?.DatosPersonales?.Nombre || "",
                SolicitanteApellido1:
                    data?.DatosPersonales?.Apellido1 || "",
                SolicitanteApellido2:
                    data?.DatosPersonales?.Apellido2 || "",
                SolicitanteIPF:
                    data?.DatosPersonales?.IPF || "",
                SolicitanteIPFTipo:
                    data?.DatosPersonales?.IPFTipo?.toString() || 1,

                SolicitanteTelefono:
                    data?.DatosPersonales?.Telefono || "",
                SolicitanteFijo:
                    data?.DatosPersonales?.Fijo || "",
                SolicitanteEmail:
                    data?.DatosPersonales_Email || "",

                SolicitanteDomicilio:
                    data?.DatosPersonales?.Domicilio || "",
                SolicitanteCodigoPostal:
                    data?.DatosPersonales?.CodigoPostal || "",
                SolicitanteProvincia:
                    data?.DatosPersonales?.CodigoProvincia || "",
                SolicitanteProvinciaDescripcion:
                    data?.DatosPersonales?.ProvinciaDescripcion || "",
                SolicitanteComunidadCodigo:
                    data?.DatosPersonales?.CodigoLocalidad || "",
            },
            // =====================================================
            // HIJOS A CARGO
            // =====================================================
            HijosACargo: fillArray(data?.HijosACargo, 1, EmptyHijosACargo),

            // =====================================================
            // DATOS ACTIVIDAD
            // =====================================================
            DatosActividad: {
                EmpresaNombre:
                    data?.DatosActividad_EmpresaNombre || "",
                EmpresaCIF:
                    data?.DatosActividad_EmpresaCIF || "",
                ExistiaEstablecimiento:
                    data?.DatosActividad_ExistiaEstablecimiento ?? false,
                EstablecimientoNombre:
                    data?.DatosActividad_EstablecimientoNombre || "",
                DomicilioActividad:
                    data?.DatosActividad_Domicilio || "",
                EstablecimientoNumero:
                    data?.DatosActividad_Numero || "",
                EstablecimientoPuerta:
                    data?.DatosActividad_Puerta || "",
                EstablecimientoPiso:
                    data?.DatosActividad_Piso || "",
                EstablecimientoEscalera:
                    data?.DatosActividad_Escalera || "",
                EstablecimientoProvincia:
                    data?.DatosActividad_CodigoProvincia || "",
                EstablecimientoProvinciaDescripcion:
                    data?.DatosActividad_ProvinciaDescripcion || "",
                EstablecimientoLocalidad:
                    data?.DatosActividad_CodigoLocalidad || "",
                EstablecimientoLocalidadDescripcion:
                    data?.DatosActividad_LocalidadDescripcion || "",
                EstablecimientoCodigoPostal:
                    data?.DatosActividad_CodigoPostal || "",
                EstablecimientoTelefono:
                    data?.DatosActividad_Telefono || "",
                EstablecimientoCorreoElectronico:
                    data?.DatosActividad_CorreoElectronico || "",
                EstablecimientoActividadEconomica:
                    data?.DatosActividad_ActividadEconomica || "",
                EstablecimientoNTrabajadores:
                    data?.DatosActividad_NumeroTrabajadoresUltimoAnio?.toString() || "",
                EmpresaCumplimientoGarantiasLaborales:
                    data?.DatosActividad_CumplimientoGarantiasLaborales
            },
            // =====================================================
            // SOCIO COOPERATIVA
            // =====================================================
            SocioCooperativa: {
                CooperativaNombre:
                    data?.SocioCooperativa_CooperativaNombre || "",
                FormaJuridica:
                    data?.SocioCooperativa_FormaJuridica || "",
                CooperativaCCC:
                    data?.SocioCooperativa_CCC || "",
                CooperativaDomicilio:
                    data?.SocioCooperativa_Domicilio || "",
                CooperativaNumero:
                    data?.SocioCooperativa_Numero || "",
                CooperativaPuerta:
                    data?.SocioCooperativa_Puerta || "",
                CooperativaoPiso:
                    data?.SocioCooperativa_Piso || "",
                CooperativaEscalera:
                    data?.SocioCooperativa_Escalera || "",
                CooperativaProvincia:
                    data?.SocioCooperativa_CodigoProvincia || "",
                CooperativaProvinciaDescripcion:
                    data?.SocioCooperativa_ProvinciaDescripcion || "",
                CooperativaLocalidad:
                    data?.SocioCooperativa_CodigoLocalidad || "",
                CooperativaLocalidadDescripcion:
                    data?.SocioCooperativa_LocalidadDescripcion || "",
                CooperativaCodigoPostal:
                    data?.SocioCooperativa_CodigoPostal || "",
                CooperativaTelefono:
                    data?.SocioCooperativa_Telefono || "",
                CooperativaCorreoElectronico:
                    data?.SocioCooperativa_CorreoElectronico || "",
                CooperativaCIF:
                    data?.SocioCooperativa_CIF || "",
                CooperativaTrabajadoresDependientes:
                    data?.SocioCooperativa_TrabajadoresDependientes?.toString() || "",
                CooperativaTrabajadoresDependientesNumero:
                    data?.SocioCooperativa_TrabajadoresDependientesNumero?.toString() || "",
                CooperativaCumplimientoGarantiasLaborales:
                    data?.SocioCooperativa_CumplimientoGarantiasLaborales
            },
            // =====================================================
            // CESE ACTIVIDAD
            // =====================================================
            CeseActividad: {
                CeseDefinitivoFechaInicioActividad:
                    data?.CeseActividad_CeseDefinitivoFechaInicioActividad || null,
                CeseDefinitivoFechaCeseActividad:
                    data?.CeseActividad_CeseDefinitivoFechaCeseActividad || null,
                CeseDefinitivoTipoCese:
                    data?.CeseActividad_TipoCeseActividad?.toString() || 0,
                CeseDefinitivoFechaReinicioActividad:
                    data?.CeseActividad_CeseDefinitivoFechaReinicioActividad || null,
                CeseParcialFechaInicioActividad:
                    data?.CeseActividad_CeseParcialFechaInicioActividad || null,
                CeseParcialFechaCeseActividad:
                    data?.CeseActividad_CeseParcialFechaCeseActividad || null,
                PeriodosCotizadosCeseActividad:
                    data?.CeseActividad_PeriodosCotizadosCeseActividad || "",
                SupuestosGenerales:
                    data?.CeseActividad_SupuestosGenerales !== undefined && data?.CeseActividad_SupuestosGenerales !== null && data?.CeseActividad_SupuestosGenerales !== ""
                        ? data.CeseActividad_SupuestosGenerales.toString()
                        : null,

                // ---------- Concurrencia de motivos ----------
                PerdidasAnyo:
                    data?.CeseActividad_Concurrencia_PerdidasAnyo ?? false,
                EjecucionesJudiciales:
                    data?.CeseActividad_Concurrencia_EjecucionesJudiciales ?? false,
                DeclaracionJudicial:
                    data?.CeseActividad_Concurrencia_DeclaracionJudicial ?? false,
                ReduccionJornada:
                    data?.CeseActividad_Concurrencia_ReduccionJornada ?? false,
                MantenerDeudas:
                    data?.CeseActividad_Concurrencia_MantenerDeudas ?? false,
                AutonomosAyudaFamiliar:
                    data?.CeseActividad_Concurrencia_AutonomosAyudaFamiliar ?? false,

                // ---------- Fuerza mayor ----------
                FuerzaMayorDefinitivo:
                    data?.CeseActividad_FuerzaMayor_Definitivo ?? false,
                FuerzaMayorTotal:
                    data?.CeseActividad_FuerzaMayor_Total ?? false,
                FuerzaMayorParcial:
                    data?.CeseActividad_FuerzaMayor_Parcial ?? false,

                // ---------- Otros motivos ----------
                OtrosMotivosCeseTRADE:
                    data?.CeseActividad_OtrosMotivosCeseTRADE !== undefined && data?.CeseActividad_OtrosMotivosCeseTRADE !== null && data?.CeseActividad_OtrosMotivosCeseTRADE !== ""
                        ? data.CeseActividad_OtrosMotivosCeseTRADE.toString()
                        : null,
                OtrosMotivosCeseCooperativa:
                    data?.CeseActividad_OtrosMotivosCeseCooperativa !== undefined && data?.CeseActividad_OtrosMotivosCeseCooperativa !== null && data?.CeseActividad_OtrosMotivosCeseCooperativa !== ""
                        ? data.CeseActividad_OtrosMotivosCeseCooperativa.toString()
                        : null,
                OtrosMotivosCeseAgrarios:
                    data?.CeseActividad_OtrosMotivosCeseAgrarios !== undefined && data?.CeseActividad_OtrosMotivosCeseAgrarios !== null && data?.CeseActividad_OtrosMotivosCeseAgrarios !== ""
                        ? data.CeseActividad_OtrosMotivosCeseAgrarios.toString()
                        : null,
                Art305Sociedad:
                    data?.CeseActividad_OtrosMotivosCeseArt305Sociedad !== undefined && data?.CeseActividad_OtrosMotivosCeseArt305Sociedad !== null && data?.CeseActividad_OtrosMotivosCeseArt305Sociedad !== ""
                        ? data.CeseActividad_OtrosMotivosCeseArt305Sociedad.toString()
                        : null
            },

            // =====================================================
            // DATOS BANCARIOS
            // =====================================================
            DatosBancarios: {
                SolicitanteIBAN:
                    data?.DatosBancarios_IBAN?.replace(/-/g, '') || ""
            },
            // =====================================================
            // PLURIACTIVIDAD
            // =====================================================
            Pluriactividad: {
                PluriactividadNombreEmpresa:
                    data?.Pluriactividad_NombreEmpresa || "",
                PluriactividadCCC:
                    data?.Pluriactividad_CCC || "",
                PluriactividadRegimen:
                    data?.Pluriactividad_CodigoRegimen || "",
                PluriactividadDomicilio:
                    data?.Pluriactividad_Domicilio || "",
                PluriactividadNumero:
                    data?.Pluriactividad_Numero || "",
                PluriactividadPuerta:
                    data?.Pluriactividad_Puerta || "",
                PluriactividadPiso:
                    data?.Pluriactividad_Piso || "",
                PluriactividadEscalera:
                    data?.Pluriactividad_Escalera || "",
                PluriactividadProvincia:
                    data?.Pluriactividad_CodigoProvincia || "",
                PluriactividadProvinciaDescripcion:
                    data?.Pluriactividad_ProvinciaDescripcion || "",
                PluriactividadLocalidad:
                    data?.Pluriactividad_CodigoLocalidad || "",
                PluriactividadLocalidadDescripcion:
                    data?.Pluriactividad_LocalidadDescripcion || "",
                PluriactividadCodigoPostal:
                    data?.Pluriactividad_CodigoPostal || "",
                PluriactividadTelefono:
                    data?.Pluriactividad_Telefono || "",
                PluriactividadCorreoElectronico:
                    data?.Pluriactividad_CorreoElectronico || "",
                PluriactividadCIF:
                    data?.Pluriactividad_CIF || "",
                PluriactividadFunciones:
                    data?.Pluriactividad_FuncionesEmpresa || "",
                PluriactividadHechoCausante:
                    data?.Pluriactividad_HechoCausante ?? false,
                PluriactividadRetribucionBruta:
                    data?.Pluriactividad_RetribucionBruta ?? false,
                PluriactividadPromedioMensual:
                    data?.Pluriactividad_PromedioMensual || "",
            },

            Documentacion: adaptDocumentacion(data?.SeccionesDocumentacion),
            // =====================================================
            // DATOS ASESORÍA
            // =====================================================
            DatosAsesoria: {
                AsesoriaNombre:
                    data?.DatosAsesoria_Nombre || "",
                AsesoriaCIF:
                    data?.DatosAsesoria_CIF || "",
                AsesoriaNumeroRed:
                    data?.DatosAsesoria_NumeroRed || ""
            },

        });

    };

    useEffect(() => {
        adaptApiResponseToDefaultValues(dataUser);
    }, [dataUser]);

    useEffect(() => {
        setDatosAPI(dataUser);
    }, [dataUser]);

    useEffect(() => {
        const currentValues = {
            SupuestosGenerales: watchSupuestosGenerales,
            OtrosMotivosCeseTRADE: watchOtrosMotivosCeseTRADE,
            OtrosMotivosCeseCooperativa: watchOtrosMotivosCeseCooperativa,
            OtrosMotivosCeseAgrarios: watchOtrosMotivosCeseAgrarios,
            Art305Sociedad: watchArt305Sociedad
        };

        const previousValues = prevExclusiveMotivosRef.current;
        const changedKey = Object.keys(currentValues).find(
            (key) => currentValues[key as keyof typeof currentValues] !== previousValues[key as keyof typeof previousValues]
        );

        if (!changedKey) {
            return;
        }

        const changedValue = currentValues[changedKey as keyof typeof currentValues];
        if (changedValue !== undefined && changedValue !== null && changedValue !== "") {
            const fieldPathMap = {
                SupuestosGenerales: "CeseActividad.SupuestosGenerales",
                OtrosMotivosCeseTRADE: "CeseActividad.OtrosMotivosCeseTRADE",
                OtrosMotivosCeseCooperativa: "CeseActividad.OtrosMotivosCeseCooperativa",
                OtrosMotivosCeseAgrarios: "CeseActividad.OtrosMotivosCeseAgrarios",
                Art305Sociedad: "CeseActividad.Art305Sociedad"
            };

            (Object.keys(currentValues) as Array<keyof typeof currentValues>)
                .filter((key) => key !== changedKey)
                .forEach((key) => {
                    if (currentValues[key] !== null && currentValues[key] !== undefined && currentValues[key] !== "") {
                        setValue(fieldPathMap[key], null, {
                            shouldDirty: true,
                            shouldValidate: true
                        });
                    }
                });
        }

        prevExclusiveMotivosRef.current = currentValues;
    }, [
        watchSupuestosGenerales,
        watchOtrosMotivosCeseTRADE,
        watchOtrosMotivosCeseCooperativa,
        watchOtrosMotivosCeseAgrarios,
        watchArt305Sociedad,
        setValue
    ]);




    const onSubmit = async (data: any) => {
        console.log(data);
        setLoader(true);
        let prestacionId = dataUser?.PrestacionId || null;
        const documentacionArray = await prepareDocumentacionArrayWithCase(data?.Documentacion || []);
        const datosEnvio = {
            Id: dataUser?.Id || null,
            externalId: dataUser?.ExternalId || 0,
            personaId: dataUser?.PersonaId || 0,
            usuarioId: dataUser?.UsuarioId || null,
            expedienteId: dataUser?.ExpedienteId || null,
            prestacionId: prestacionId,
            acepto: data?.Acepto ?? false,
            impersonadorId: dataUser?.ImpersonadorId || 0,

            // =====================================================
            // DATOS PERSONALES
            // =====================================================
            datosPersonales: {
                nombre: data?.DatosPersonales?.SolicitanteNombre || null,
                apellido1: data?.DatosPersonales?.SolicitanteApellido1 || null,
                apellido2: data?.DatosPersonales?.SolicitanteApellido2 || null,
                ipf: data?.DatosPersonales?.SolicitanteIPF || null,
                ipfTipo: parseInt(data?.DatosPersonales?.SolicitanteIPFTipo) || 1,
                telefono: data?.DatosPersonales?.SolicitanteTelefono || null,
                fijo: data?.DatosPersonales?.SolicitanteFijo || null,
                domicilio: data?.DatosPersonales?.SolicitanteDomicilio || null,
                codigoPostal: data?.DatosPersonales?.SolicitanteCodigoPostal || null,
                provinciaDescripcion: data?.DatosPersonales?.SolicitanteProvinciaDescripcion || null,
                codigoProvincia: data?.DatosPersonales?.SolicitanteProvincia || null,
                codigoLocalidad: data?.DatosPersonales?.SolicitanteComunidadCodigo || null,
                localidadDescripcion: data?.DatosPersonales?.SolicitanteComunidadCodigoDescripcion || null,
                numeroSeguridadSocial: data?.DatosPersonales?.SolicitanteNumeroSS || "",
            },
            datosPersonales_FechaNacimiento: data?.DatosPersonales?.SolicitanteFechaNacimiento || null,
            datosPersonales_Email: data?.DatosPersonales?.SolicitanteEmail || null,
            datosPersonales_TipoIRPFVoluntario: data?.DatosPersonales?.SolicitanteIRPF
                ? parseFloat(data.DatosPersonales.SolicitanteIRPF)
                : null,
            datosPersonales_CodigoRegimen: data?.DatosAutonomo?.RegimenSS || null,
            datosPersonales_AutonomoColaboradorAyudaFamiliar:
                data?.DatosAutonomo?.TrabajadorAutonomo?.ColaboradorAyudaFamiliar ?? false,
            datosPersonales_AdministradorConsejeroSociedadMercantil:
                data?.DatosAutonomo?.TrabajadorAutonomo?.AdministradorConsejeroMercantil ?? false,
            datosPersonales_SocioPrestaOtrosServiciosSociedadMercantil:
                data?.DatosAutonomo?.TrabajadorAutonomo?.SocioServiciosSociedadMercantil ?? false,
            datosPersonales_ComuneroSocioOtrasSociedadesMercantiles:
                data?.DatosAutonomo?.TrabajadorAutonomo?.ComuneroSociosOtrasSociedades ?? false,
            datosPersonales_AutonomoEconomicamenteDependiente:
                data?.DatosAutonomo?.TrabajadorAutonomo?.EconomicamenteDependiente ?? false,
            datosPersonales_SocioCooperativaTrabajoAsociado:
                data?.DatosAutonomo?.TrabajadorAutonomo?.CooperativaTrabajoAsociado ?? false,
            datosPersonales_AutonomoActividadProfesionalConjuntamente:
                data?.DatosAutonomo?.TrabajadorAutonomo?.AutonomoActividadProfesionalConjuntamente ?? false,
            datosPersonales_ProfesionalColegiado:
                data?.DatosAutonomo?.SituacionSolicitante?.EsProfesionalColegiado ?? false,
            datosPersonales_PerceptorPrestacionesAyudasParalizacionFlota:
                data?.DatosAutonomo?.SituacionSolicitante?.PrestacionesAyudasParalizacionFlota ?? false,
            datosPersonales_PerceptorOtrasPrestacionesSeguridadSocial:
                data?.DatosAutonomo?.SituacionSolicitante?.OtrasPrestacionesSeguridadSocial ?? false,
            datosPersonales_PerceptorPensionesSeguridadSocial:
                data?.DatosAutonomo?.SituacionSolicitante?.PensionesSeguridadSocial ?? false,
            datosPersonales_TieneDeudasSeguridadSocial:
                data?.DatosAutonomo?.SituacionSolicitante?.TieneDeudasSeguridadSocial ?? false,
            datosPersonales_TieneAplazadasCuotasTesoreria:
                data?.DatosAutonomo?.SituacionSolicitante?.TieneAplazadasCuotasTesoreria ?? false,
            datosPersonales_Tipo1: data?.DatosAutonomo?.Tipo1 || null,
            datosPersonales_Tipo2: data?.DatosAutonomo?.Tipo2 || null,

            // =====================================================
            // HIJOS A CARGO
            // =====================================================
            hijosACargo: (data?.HijosACargo || []).map((hijo: any) => ({
                ...(hijo?.Id ? { id: hijo.Id } : {}),
                externalId: hijo?.ExternalId || 0,
                ...(hijo?.FormSolPECATAId ? { formSolPECATAId: hijo.FormSolPECATAId } : {}),
                nombreApellido: hijo?.NombreApellido || null,
                hijoIPF: hijo?.HijoIPF || null,
                fechaNacimiento: hijo?.FechaNacimiento || null,
                estadoCivil: hijo?.EstadoCivil || null,
                incapacitado: hijo?.Incapacitado ? parseInt(hijo.Incapacitado) : 0,
                trabajando: hijo?.Trabajando ?? false,
                rentaAnoAnterior: hijo?.RentaAnoAnterior ? parseFloat(hijo.RentaAnoAnterior) : 0,
                rentaAnoActual: hijo?.RentaAnoActual ? parseFloat(hijo.RentaAnoActual) : 0,
            })),

            // =====================================================
            // DATOS ACTIVIDAD
            // =====================================================
            datosActividad_EmpresaNombre: data?.DatosActividad?.EmpresaNombre || null,
            datosActividad_EmpresaCIF: data?.DatosActividad?.EmpresaCIF || null,
            datosActividad_ExistiaEstablecimiento: data?.DatosActividad?.ExistiaEstablecimiento ?? true,
            datosActividad_EstablecimientoNombre: data?.DatosActividad?.EstablecimientoNombre || null,
            datosActividad_Domicilio: data?.DatosActividad?.DomicilioActividad || null,
            datosActividad_Numero: data?.DatosActividad?.EstablecimientoNumero || null,
            datosActividad_Puerta: data?.DatosActividad?.EstablecimientoPuerta || null,
            datosActividad_Piso: data?.DatosActividad?.EstablecimientoPiso || null,
            datosActividad_Escalera: data?.DatosActividad?.EstablecimientoEscalera || null,
            datosActividad_CodigoLocalidad: data?.DatosActividad?.EstablecimientoLocalidad || null,
            datosActividad_LocalidadDescripcion: data?.DatosActividad?.EstablecimientoLocalidadDescripcion || null,
            datosActividad_CodigoProvincia: data?.DatosActividad?.EstablecimientoProvincia || null,
            datosActividad_ProvinciaDescripcion: data?.DatosActividad?.EstablecimientoProvinciaDescripcion || null,
            datosActividad_CodigoPostal: data?.DatosActividad?.EstablecimientoCodigoPostal || null,
            datosActividad_Telefono: data?.DatosActividad?.EstablecimientoTelefono || null,
            datosActividad_CorreoElectronico: data?.DatosActividad?.EstablecimientoCorreoElectronico || null,
            datosActividad_ActividadEconomica: data?.DatosActividad?.EstablecimientoActividadEconomica || null,
            datosActividad_NumeroTrabajadoresUltimoAnio: data?.DatosActividad?.EstablecimientoNTrabajadores
                ? parseInt(data.DatosActividad.EstablecimientoNTrabajadores)
                : 0,
            datosActividad_CumplimientoGarantiasLaborales:
                data?.DatosActividad?.EmpresaCumplimientoGarantiasLaborales,

            // =====================================================
            // SOCIO COOPERATIVA
            // =====================================================
            socioCooperativa_CooperativaNombre: data?.SocioCooperativa?.CooperativaNombre || null,
            socioCooperativa_FormaJuridica: data?.SocioCooperativa?.FormaJuridica || null,
            socioCooperativa_CCC: data?.SocioCooperativa?.CooperativaCCC || null,
            socioCooperativa_Domicilio: data?.SocioCooperativa?.CooperativaDomicilio || null,
            socioCooperativa_Numero: data?.SocioCooperativa?.CooperativaNumero || null,
            socioCooperativa_Puerta: data?.SocioCooperativa?.CooperativaPuerta || null,
            socioCooperativa_Piso: data?.SocioCooperativa?.CooperativaoPiso || null,
            socioCooperativa_Escalera: data?.SocioCooperativa?.CooperativaEscalera || null,
            socioCooperativa_CodigoLocalidad: data?.SocioCooperativa?.CooperativaLocalidad || null,
            socioCooperativa_LocalidadDescripcion: data?.SocioCooperativa?.CooperativaLocalidadDescripcion || null,
            socioCooperativa_CodigoProvincia: data?.SocioCooperativa?.CooperativaProvincia || null,
            socioCooperativa_ProvinciaDescripcion: data?.SocioCooperativa?.CooperativaProvinciaDescripcion || null,
            socioCooperativa_CodigoPostal: data?.SocioCooperativa?.CooperativaCodigoPostal || null,
            socioCooperativa_Telefono: data?.SocioCooperativa?.CooperativaTelefono || null,
            socioCooperativa_CorreoElectronico: data?.SocioCooperativa?.CooperativaCorreoElectronico || null,
            socioCooperativa_CIF: data?.SocioCooperativa?.CooperativaCIF || null,
            socioCooperativa_TrabajadoresDependientes: data?.SocioCooperativa?.CooperativaTrabajadoresDependientes
                ? parseInt(data.SocioCooperativa.CooperativaTrabajadoresDependientes)
                : null,
            socioCooperativa_TrabajadoresDependientesNumero: data?.SocioCooperativa?.CooperativaTrabajadoresDependientesNumero
                ? parseInt(data.SocioCooperativa.CooperativaTrabajadoresDependientesNumero)
                : null,
            socioCooperativa_CumplimientoGarantiasLaborales:
                data?.SocioCooperativa?.CooperativaCumplimientoGarantiasLaborales,

            // =====================================================
            // PLURIACTIVIDAD
            // =====================================================
            pluriactividad_NombreEmpresa: data?.Pluriactividad?.PluriactividadNombreEmpresa || null,
            pluriactividad_CCC: data?.Pluriactividad?.PluriactividadCCC || null,
            pluriactividad_CodigoRegimen: data?.Pluriactividad?.PluriactividadRegimen || null,
            pluriactividad_Regimen: data?.Pluriactividad?.PluriactividadRegimenDescripcion || null,
            pluriactividad_Domicilio: data?.Pluriactividad?.PluriactividadDomicilio || null,
            pluriactividad_Numero: data?.Pluriactividad?.PluriactividadNumero || null,
            pluriactividad_Puerta: data?.Pluriactividad?.PluriactividadPuerta || null,
            pluriactividad_Piso: data?.Pluriactividad?.PluriactividadPiso || null,
            pluriactividad_Escalera: data?.Pluriactividad?.PluriactividadEscalera || null,
            pluriactividad_CodigoLocalidad: data?.Pluriactividad?.PluriactividadLocalidad || null,
            pluriactividad_LocalidadDescripcion: data?.Pluriactividad?.PluriactividadLocalidadDescripcion || null,
            pluriactividad_CodigoProvincia: data?.Pluriactividad?.PluriactividadProvincia || null,
            pluriactividad_ProvinciaDescripcion: data?.Pluriactividad?.PluriactividadProvinciaDescripcion || null,
            pluriactividad_CodigoPostal: data?.Pluriactividad?.PluriactividadCodigoPostal || null,
            pluriactividad_Telefono: data?.Pluriactividad?.PluriactividadTelefono || null,
            pluriactividad_CorreoElectronico: data?.Pluriactividad?.PluriactividadCorreoElectronico || null,
            pluriactividad_CIF: data?.Pluriactividad?.PluriactividadCIF || null,
            pluriactividad_FuncionesEmpresa: data?.Pluriactividad?.PluriactividadFunciones || null,
            pluriactividad_HechoCausante: data?.Pluriactividad?.PluriactividadHechoCausante ?? false,
            pluriactividad_RetribucionBruta: data?.Pluriactividad?.PluriactividadRetribucionBruta ?? false,
            pluriactividad_PromedioMensual: data?.Pluriactividad?.PluriactividadPromedioMensual || null,

            // =====================================================
            // CESE ACTIVIDAD
            // =====================================================
            ceseActividad_CeseDefinitivoFechaInicioActividad:
                data?.CeseActividad?.CeseDefinitivoFechaInicioActividad || null,
            ceseActividad_CeseDefinitivoFechaCeseActividad:
                data?.CeseActividad?.CeseDefinitivoFechaCeseActividad || null,
            ceseActividad_TipoCeseActividad: data?.CeseActividad?.CeseDefinitivoTipoCese
                ? parseInt(data.CeseActividad.CeseDefinitivoTipoCese)
                : 0,
            ceseActividad_CeseDefinitivoFechaReinicioActividad:
                data?.CeseActividad?.CeseDefinitivoFechaReinicioActividad || null,
            ceseActividad_CeseParcialFechaInicioActividad:
                data?.CeseActividad?.CeseParcialFechaInicioActividad || null,
            ceseActividad_CeseParcialFechaCeseActividad:
                data?.CeseActividad?.CeseParcialFechaCeseActividad || null,
            ceseActividad_PeriodosCotizadosCeseActividad:
                data?.CeseActividad?.PeriodosCotizadosCeseActividad || "",
            ceseActividad_SupuestosGenerales: data?.CeseActividad?.SupuestosGenerales !== undefined && data?.CeseActividad?.SupuestosGenerales !== null && data?.CeseActividad?.SupuestosGenerales !== ""
                ? parseInt(data.CeseActividad.SupuestosGenerales)
                : null,
            ceseActividad_Concurrencia: !!(
                data?.CeseActividad?.PerdidasAnyo ||
                data?.CeseActividad?.EjecucionesJudiciales ||
                data?.CeseActividad?.DeclaracionJudicial ||
                data?.CeseActividad?.ReduccionJornada ||
                data?.CeseActividad?.MantenerDeudas ||
                data?.CeseActividad?.AutonomosAyudaFamiliar
            ),
            ceseActividad_Concurrencia_PerdidasAnyo: data?.CeseActividad?.PerdidasAnyo ?? false,
            ceseActividad_Concurrencia_EjecucionesJudiciales: data?.CeseActividad?.EjecucionesJudiciales ?? false,
            ceseActividad_Concurrencia_DeclaracionJudicial: data?.CeseActividad?.DeclaracionJudicial ?? false,
            ceseActividad_Concurrencia_ReduccionJornada: data?.CeseActividad?.ReduccionJornada ?? false,
            ceseActividad_Concurrencia_MantenerDeudas: data?.CeseActividad?.MantenerDeudas ?? false,
            ceseActividad_Concurrencia_AutonomosAyudaFamiliar: data?.CeseActividad?.AutonomosAyudaFamiliar ?? false,
            ceseActividad_FuerzaMayor: !!(
                data?.CeseActividad?.FuerzaMayorDefinitivo ||
                data?.CeseActividad?.FuerzaMayorTotal ||
                data?.CeseActividad?.FuerzaMayorParcial
            ),
            ceseActividad_FuerzaMayor_Definitivo: data?.CeseActividad?.FuerzaMayorDefinitivo ?? false,
            ceseActividad_FuerzaMayor_Total: data?.CeseActividad?.FuerzaMayorTotal ?? false,
            ceseActividad_FuerzaMayor_Parcial: data?.CeseActividad?.FuerzaMayorParcial ?? false,
            ceseActividad_OtrosMotivosCeseTRADE: data?.CeseActividad?.OtrosMotivosCeseTRADE !== undefined && data?.CeseActividad?.OtrosMotivosCeseTRADE !== null && data?.CeseActividad?.OtrosMotivosCeseTRADE !== ""
                ? parseInt(data.CeseActividad.OtrosMotivosCeseTRADE)
                : null,
            ceseActividad_OtrosMotivosCeseCooperativa: data?.CeseActividad?.OtrosMotivosCeseCooperativa !== undefined && data?.CeseActividad?.OtrosMotivosCeseCooperativa !== null && data?.CeseActividad?.OtrosMotivosCeseCooperativa !== ""
                ? parseInt(data.CeseActividad.OtrosMotivosCeseCooperativa)
                : null,
            ceseActividad_OtrosMotivosCeseAgrarios: data?.CeseActividad?.OtrosMotivosCeseAgrarios !== undefined && data?.CeseActividad?.OtrosMotivosCeseAgrarios !== null && data?.CeseActividad?.OtrosMotivosCeseAgrarios !== ""
                ? parseInt(data.CeseActividad.OtrosMotivosCeseAgrarios)
                : null,
            ceseActividad_OtrosMotivosCeseArt305Sociedad: data?.CeseActividad?.Art305Sociedad !== undefined && data?.CeseActividad?.Art305Sociedad !== null && data?.CeseActividad?.Art305Sociedad !== ""
                ? parseInt(data.CeseActividad.Art305Sociedad)
                : null,

            // =====================================================
            // DATOS BANCARIOS
            // =====================================================
            datosBancarios_IBAN: data?.DatosBancarios?.SolicitanteIBAN
                ?.replace(/(.{4})(.{4})(.{4})(.{2})/, '$1-$2-$3-$4-') || null,

            // =====================================================
            // DATOS ASESORÍA
            // =====================================================
            datosAsesoria_Nombre: data?.DatosAsesoria?.AsesoriaNombre || "",
            datosAsesoria_CIF: data?.DatosAsesoria?.AsesoriaCIF || "",
            datosAsesoria_NumeroRed: data?.DatosAsesoria?.AsesoriaNumeroRed || "",

            // =====================================================
            // DOCUMENTACIÓN
            // =====================================================
            documentacion: documentacionArray
        };

        console.log("Payload envío:", datosEnvio);

        if (info) {
            await createFormularioPECATA(dataUser?.UsuarioId.toString(), datosEnvio, onSuccess)
            setBloquearEnvio(true);
        } else {
            await updateFormularioPECATAById(dataUser?.Id, dataUser?.Id, datosEnvio)
            setBloquearEnvio(true);
        }


        setTimeout(() => {
            setLoader(false);
        }, 500);
    };





    return (
        <FormProvider {...formMethods}>
            <div className="container form--simple-styled" id="formDeltawithoutleave">

                {/* ////////////// OBSERVACIONES DEL GESTOR A LA SOLICITUD ////////////// */}
                <FormObservaciones observaciones={datosAPI?.Observaciones} titulo={'Observaciones del Gestor a la Solicitud'} />

                <Loader activeLoader={loader || loadingCreateFormularioPECATA || loadingUpdateFormularioPECATAById} label="Cargando Formulario"></Loader>








                {/* ////////////// COMIENZO FORMULARIO ////////////// */}
                {/* ////////////// DATOS DEL TRABAJADOR ////////////// */}

                <FormInfoCreateUpdate
                    isCreate={info}
                    estadoFormulario={datosAPI?.EstadoFormulario ?? datosAPI?.estadoFormulario ?? dataUser?.EstadoFormulario ?? dataUser?.estadoFormulario}
                    estadoFormularioDescripcion={datosAPI?.EstadoFormularioDescripcion ?? datosAPI?.estadoFormularioDescripcion ?? dataUser?.EstadoFormularioDescripcion ?? dataUser?.estadoFormularioDescripcion}
                    fechaActualizacionEstado={datosAPI?.FechaActualizacionEstado ?? datosAPI?.fechaActualizacionEstado ?? dataUser?.FechaActualizacionEstado ?? dataUser?.fechaActualizacionEstado}
                />
                <FormDatosPersonales activarFechaNacimiento={true} activarSS={true} activarIRPF={true} emailVisible={true} />

                <AccordionForm title={'Datos del Autónomo'} expandedInit={false} nombreError='DatosAutonomo' >
                    <div className="row mb-4">
                        <div className="col-xl-12">


                            <FieldsetContainer legend="" disabled={false}>
                                <div className={`col-xl-${12} col-md-${12} col-12`}>
                                    <div className="input-block">
                                        <label htmlFor="DatosAutonomo.RegimenSS" className="input-block__label m-0">
                                            Régimen de la
                                            Seguridad social
                                        </label>

                                        <select
                                            name="DatosAutonomo.RegimenSS"
                                            id="DatosAutonomo.RegimenSS"
                                            {...register("DatosAutonomo.RegimenSS", {

                                            })}
                                            className="form-select"
                                        >
                                            <option value={'0521'}>Régimen Especial Trabajadores Autónomos</option>
                                            <option value={'0825'}>Régimen Especial trabajadores del Mar. Áutónomos</option>
                                            <option value={'0721'}>Régimen Especial Agrario. Trabajadores por Cuenta Propia</option>
                                        </select>
                                    </div>
                                </div>





                                <FormInputCheckboxTable
                                    title={"Trabajador/a autónomo/a"}
                                    required='Debe seleccionar al menos una opción.'
                                    col={12}
                                    labels={[
                                        "Autónomo/a colaborador/a ayuda familiar",
                                        "Administrador o Consejero de una Sociedad Mercantil",
                                        "Socio que preste otros servicios a una Sociedad Mercantil",
                                        "Comunero o socios de otras Sociedades No Mercantiles",
                                        "Trabajador/a autónomo/a económicamente dependiente (TRADE)",
                                        "Socio trabajador de cooperativa de trabajo asociado",
                                        "Trabajador/a autónomo/a que ejerce su actividad profesional conjuntamente"
                                    ]}
                                    names={[
                                        "DatosAutonomo.TrabajadorAutonomo.ColaboradorAyudaFamiliar",
                                        "DatosAutonomo.TrabajadorAutonomo.AdministradorConsejeroMercantil",
                                        "DatosAutonomo.TrabajadorAutonomo.SocioServiciosSociedadMercantil",
                                        "DatosAutonomo.TrabajadorAutonomo.ComuneroSociosOtrasSociedades",
                                        "DatosAutonomo.TrabajadorAutonomo.EconomicamenteDependiente",
                                        "DatosAutonomo.TrabajadorAutonomo.CooperativaTrabajoAsociado",
                                        "DatosAutonomo.TrabajadorAutonomo.AutonomoActividadProfesionalConjuntamente"
                                    ]}
                                />


                                <FormInputCheckboxTable
                                    title="Situaciones del solicitante"
                                    labels={[
                                        "Es profesional colegiado",
                                        "Es perceptor/a de prestaciones de ayudas por paralización de la flota",
                                        "Es perceptor de otras prestaciones de la Seguridad Social",
                                        "Es perceptor/a de pensiones de la Seguridad Social",
                                        "¿Tiene deudas con la Seguridad Social?",
                                        "¿Tiene aplazadas cuotas por la Tesorería General de la Seguridad Social?"
                                    ]}
                                    names={[
                                        "DatosAutonomo.SituacionSolicitante.EsProfesionalColegiado",
                                        "DatosAutonomo.SituacionSolicitante.PrestacionesAyudasParalizacionFlota",
                                        "DatosAutonomo.SituacionSolicitante.OtrasPrestacionesSeguridadSocial",
                                        "DatosAutonomo.SituacionSolicitante.PensionesSeguridadSocial",
                                        "DatosAutonomo.SituacionSolicitante.TieneDeudasSeguridadSocial",
                                        "DatosAutonomo.SituacionSolicitante.TieneAplazadasCuotasTesoreria"
                                    ]}
                                    required="Debes responder al menos una opción"
                                    col={12}

                                />

                                <AccordionDisplay dataUser={dataUser} visibility={watch('DatosAutonomo.SituacionSolicitante.OtrasPrestacionesSeguridadSocial') === true} fields={['DatosAutonomo.Tipo1']}>
                                    <FormInputText
                                        name='DatosAutonomo.Tipo1'
                                        id='DatosAutonomo.Tipo1'
                                        label='Tipo'
                                        md={12}
                                        xl={12}
                                        disabled={false}
                                        modal='Tipo sobre si es perceptor de otras prestaciones de la Seguridad Social'
                                    />
                                </AccordionDisplay>
                                <AccordionDisplay dataUser={dataUser} visibility={watch('DatosAutonomo.SituacionSolicitante.PensionesSeguridadSocial') === true} fields={['DatosAutonomo.Tipo2']}>
                                    <FormInputText
                                        name='DatosAutonomo.Tipo2'
                                        id='DatosAutonomo.Tipo2'
                                        label='Tipo'
                                        md={12}
                                        xl={12}
                                        disabled={false}
                                        modal='Tipo sobre si es perceptor de pensiones de la Seguridad Social'
                                    />
                                </AccordionDisplay>
                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>




                <AccordionForm title={'Datos de los Hijos/as a cargo'} expandedInit={false} nombreError='HijosACargo' modal='Se entenderá por hijos a cargo, cuando éstos sean menores de 26 años o mayores con una discapacidad en grado
igual o superior al 33%, carezcan de rentas de cualquier naturaleza iguales o superiores al salario mínimo interprofesional
excluida parte proporcional de las pagas extraordinarias, y convivan con el beneficiario.' >
                    <div className="row mb-4">
                        <div className="col-xl-12">


                            <FieldsetContainer legend="" disabled={false}>
                                <FormInputTable
                                    name="HijosACargo"
                                    heads={["Nombre y Apellidos", "DNI, NIE o Pasaporte", "Fecha Nacimiento", "Estado Civil", "Incapacitado (%)", "Trabaja SI/NO", "Renta Año Anterior", "Renta Año Actual"]}
                                    nameHeads={["NombreApellido", "HijoIPF", "FechaNacimiento", "EstadoCivil", "Incapacitado", "Trabajando", "RentaAnoAnterior", "RentaAnoActual"]}
                                    removeButton={true}
                                    addButton={true}
                                    widthColumn={[2, 2, 1, 1, 1, 1, 2, 2]}
                                    validateFunction={undefined}
                                    inputType={[1, 1, 4, 1, 3, 5, 3, 3]}
                                    arrayModal={["", "", "", "", "", "", "", ""]}
                                />
                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>

                {/* ------------------ DATOS ACTIVIDAD APARTADO 3 ------------------ */}
                <AccordionForm title={'Datos de la Actividad'} expandedInit={false} nombreError='DatosActividad' >
                    <div className="row mb-4">
                        <div className="col-xl-12">


                            <FieldsetContainer legend="" disabled={false}>
                                <FormInputText
                                    name='DatosActividad.EmpresaNombre'
                                    id='DatosActividad.NombreEmpresa'
                                    label='Nombre de la empresa propia'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />

                                <FormInputText
                                    name='DatosActividad.EmpresaCIF'
                                    id='DatosActividad.EmpresaCIF'
                                    label='CIF de la empresa propia'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />


                                <FormInputCheckboxTable
                                    title={"Marque si existia un establecimiento abierto al público"}

                                    col={12}
                                    labels={[
                                        "Existía establecimiento abierto al público",
                                    ]}
                                    names={[
                                        "DatosActividad.ExistiaEstablecimiento",
                                    ]}

                                />

                                <FormInputText
                                    name='DatosActividad.EstablecimientoNombre'
                                    id='DatosActividad.EstablecimientoNombre'
                                    label='Nombre del establecimiento'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />
                                <FormInputText
                                    name='DatosActividad.DomicilioActividad'
                                    id='DatosActividad.DomicilioActividad'
                                    label='Domicilio de la Actividad'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />
                                <FormInputText
                                    name='DatosActividad.EstablecimientoNumero'
                                    id='DatosActividad.EstablecimientoNumero'
                                    label='Número'
                                    md={3}
                                    xl={3}
                                    disabled={false}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten numeros enteros'
                                />
                                <FormInputText
                                    name='DatosActividad.EstablecimientoPuerta'
                                    id='DatosActividad.EstablecimientoPuerta'
                                    label='Puerta'
                                    md={3}
                                    xl={3}
                                    disabled={false}

                                    patternMessage='Solo se permiten numeros enteros'
                                />
                                <FormInputText
                                    name='DatosActividad.EstablecimientoPiso'
                                    id='DatosActividad.EstablecimientoPiso'
                                    label='Piso'
                                    md={3}
                                    xl={3}

                                    disabled={false}
                                />
                                <FormInputText
                                    name='DatosActividad.EstablecimientoEscalera'
                                    id='DatosActividad.EstablecimientoEscalera'
                                    label='Esc./Bloque'
                                    md={3}
                                    xl={3}

                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />

                                <div className="col-xl-6 col-md-6">
                                    <Province
                                        errors={errors}
                                        register={register}
                                        idCode={'DatosActividad.EstablecimientoProvincia'}
                                        watchProvinceDescription={watchProvinciaDescDatosActividad}
                                        idDescription={'DatosActividad.EstablecimientoProvinciaDescripcion'}
                                        watchProvinceCode={watchProvinciaDatosActividad}
                                        setValue={setValue}
                                        disabled={false}
                                    />
                                </div>
                                <div className="col-xl-6 col-md-6">
                                    <TestCommunity
                                        errors={errors}
                                        register={register}
                                        setValue={setValue}
                                        watchProvinceCode={watchProvinciaDatosActividad}
                                        watchCommunityCode={watchCommDatosActividad}
                                        watchCommunityDescription={watchCommDescDatosActividad}
                                        idCode={'DatosActividad.EstablecimientoLocalidad'}
                                        idDescription={'DatosActividad.EstablecimientoLocalidadDescripcion'}
                                        filterByProvince={true}
                                        disabled={false}
                                    />
                                </div>

                                <FormInputText
                                    name='DatosActividad.EstablecimientoCodigoPostal'
                                    id='DatosActividad.EstablecimientoCodigoPostal'
                                    label='Codigo Postal'
                                    md={4}
                                    xl={4}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />

                                <FormInputText
                                    name='DatosActividad.EstablecimientoTelefono'
                                    id='DatosActividad.EstablecimientoTelefono'
                                    label='Teléfono'
                                    md={4}
                                    xl={4}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />

                                <FormInputEmail
                                    name='DatosActividad.EstablecimientoCorreoElectronico'
                                    id='DatosActividad.EstablecimientoCorreoElectronico'
                                    label='Correo Electrónico'
                                    md={4}
                                    xl={4}
                                    disabled={false}
                                />

                                <FormInputText
                                    name='DatosActividad.EstablecimientoActividadEconomica'
                                    id='DatosActividad.EstablecimientoActividadEconomica'
                                    label='Actividad Económica'
                                    md={6}
                                    xl={6}

                                    disabled={false}
                                />
                                <FormInputText
                                    name='DatosActividad.EstablecimientoNTrabajadores'
                                    id='DatosActividad.EstablecimientoNTrabajadores'
                                    label='Nº de trabajadores/as por cuenta ajena en el último año'
                                    md={6}
                                    xl={6}

                                    disabled={false}
                                />


                                <FormInputYesNo
                                    modal='En caso afirmativo, debe cumplimentar "Declaración jurada de cumplimiento de las garantías laborales" (disponible en apartado: Mis Gestiones --> Prestación Cese Actividad Trabajadores Autónomos)'
                                    name="DatosActividad.EmpresaCumplimientoGarantiasLaborales"
                                    title="¿Ha realizado el cumplimiento de las garantías, obligaciones y procedimientos de la legislación laboral con sus trabajadores?   "
                                    required='Debe contestar si ha realizado el cumplimiento de las garantías, obligaciones y procedimientos de la legislación laboral con sus trabajadores'
                                />
                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>

                {/* ------------------ COOPERATIVA SOCIO APARTADO 4 ------------------ */}
                <AccordionForm title={'Socio/a trabajador/a de cooperativa de trabajo asociado o similares'} expandedInit={false} nombreError='SocioCooperativa' >
                    <div className="row mb-4">
                        <div className="col-xl-12">


                            <FieldsetContainer legend="" disabled={false}>
                                <FormInputText
                                    name='SocioCooperativa.CooperativaNombre'
                                    id='SocioCooperativa.CooperativaNombre'
                                    label='Nombre de la Cooperativa'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />

                                <FormInputText
                                    name='SocioCooperativa.FormaJuridica'
                                    id='SocioCooperativa.FormaJuridica'
                                    label='Forma Jurídica'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />

                                <FormInputText
                                    name='SocioCooperativa.CooperativaCCC'
                                    id='SocioCooperativa.CooperativaCCC'
                                    label='CCC'
                                    md={6}
                                    xl={6}
                                    pattern={/^[0-9]+$/}
                                    maxLength={11}
                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />
                                <FormInputText
                                    name='SocioCooperativa.CooperativaDomicilio'
                                    id='SocioCooperativa.CooperativaDomicilio'
                                    label='Domicilio de la Actividad'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />

                                <FormInputText
                                    name='SocioCooperativa.CooperativaNumero'
                                    id='SocioCooperativa.CooperativaNumero'
                                    label='Número'
                                    md={3}
                                    xl={3}
                                    disabled={false}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten numeros enteros'
                                />
                                <FormInputText
                                    name='SocioCooperativa.CooperativaPuerta'
                                    id='SocioCooperativa.CooperativaPuerta'
                                    label='Puerta'
                                    md={3}
                                    xl={3}
                                    disabled={false}

                                    patternMessage='Solo se permiten numeros enteros'
                                />
                                <FormInputText
                                    name='SocioCooperativa.CooperativaoPiso'
                                    id='SocioCooperativa.CooperativaPiso'
                                    label='Piso'
                                    md={3}
                                    xl={3}

                                    disabled={false}
                                />
                                <FormInputText
                                    name='SocioCooperativa.CooperativaEscalera'
                                    id='SocioCooperativa.CooperativaEscalera'
                                    label='Esc./Bloque'
                                    md={3}
                                    xl={3}

                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />


                                <div className="col-xl-6 col-md-6">
                                    <Province
                                        errors={errors}
                                        register={register}
                                        idCode={'SocioCooperativa.CooperativaProvincia'}
                                        watchProvinceDescription={watchProvinciaDescCooperativa}
                                        idDescription={'SocioCooperativa.CooperativaProvinciaDescripcion'}
                                        watchProvinceCode={watchProvinciaCooperativa}
                                        setValue={setValue}
                                        disabled={false}
                                    />
                                </div>
                                <div className="col-xl-6 col-md-6">
                                    <TestCommunity
                                        errors={errors}
                                        register={register}
                                        setValue={setValue}
                                        watchProvinceCode={watchProvinciaCooperativa}
                                        watchCommunityCode={watchCommCooperativa}
                                        watchCommunityDescription={watchCommDescCooperativa}
                                        idCode={'SocioCooperativa.CooperativaLocalidad'}
                                        idDescription={'SocioCooperativa.CooperativaLocalidadDescripcion'}
                                        filterByProvince={true}
                                        disabled={false}
                                    />
                                </div>

                                <FormInputText
                                    name='SocioCooperativa.CooperativaCodigoPostal'
                                    id='SocioCooperativa.CooperativaCodigoPostal'
                                    label='Codigo Postal'
                                    md={4}
                                    xl={4}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />

                                <FormInputText
                                    name='SocioCooperativa.CooperativaTelefono'
                                    id='SocioCooperativa.CooperativaTelefono'
                                    label='Teléfono'
                                    md={4}
                                    xl={4}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />

                                <FormInputEmail
                                    name='SocioCooperativa.CooperativaCorreoElectronico'
                                    id='SocioCooperativa.CooperativaCorreoElectronico'
                                    label='Correo Electrónico'
                                    md={4}
                                    xl={4}
                                    disabled={false}
                                />


                                <FormInputText
                                    name='SocioCooperativa.CooperativaCIF'
                                    id='SocioCooperativa.CooperativaCIF'
                                    label='CIF de la empresa'
                                    md={4}
                                    xl={4}

                                    disabled={false}
                                />
                                <FormInputText
                                    name='SocioCooperativa.CooperativaTrabajadoresDependientes'
                                    id='SocioCooperativa.CooperativaTrabajadoresDependientes'
                                    label='Trabajadores dependientes'
                                    md={4}
                                    xl={4}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />
                                <FormInputText
                                    name='SocioCooperativa.CooperativaTrabajadoresDependientesNumero'
                                    id='SocioCooperativa.CooperativaTrabajadoresDependientesNumero'
                                    label='Número de trabajadores dependientes'
                                    md={4}
                                    xl={4}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />
                                <FormInputYesNo
                                    modal='En caso afirmativo, debe cumplimentar "Declaración jurada de cumplimiento de las garantías laborales" (disponible en apartado: Mis Gestiones --> Prestación Cese Actividad Trabajadores Autónomos)'
                                    name="SocioCooperativa.CooperativaCumplimientoGarantiasLaborales"
                                    title="¿Ha realizado el cumplimiento de las garantías, obligaciones y procedimientos de la legislación laboral con sus trabajadores?   "
                                    required='Debe contestar si ha realizado el cumplimiento de las garantías, obligaciones y procedimientos de la legislación laboral con sus trabajadores'

                                />
                            </FieldsetContainer>


                        </div>
                    </div>
                </AccordionForm>


                {/* ------------------ PLURIACTIVIDAD APARTADO 5 ------------------ */}
                <AccordionForm title={'Pluriactividad'} expandedInit={false} nombreError='Pluriactividad' >
                    <div className="row mb-4">
                        <div className="col-xl-12">


                            <FieldsetContainer legend="" disabled={false}>

                                <FormInputText
                                    name='Pluriactividad.PluriactividadNombreEmpresa'
                                    id='Pluriactividad.PluriactividadNombreEmpresa'
                                    label='Nombre de la Empresa'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />

                                <FormInputText
                                    name='Pluriactividad.PluriactividadCCC'
                                    id='Pluriactividad.PluriactividadCCC'
                                    label='CCC'
                                    md={6}
                                    xl={6}
                                    pattern={/^[0-9]+$/}
                                    maxLength={11}
                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />

                                <InputRegimenFormularios
                                    name={'Pluriactividad.PluriactividadRegimen'}
                                    md={6}
                                    xl={6}

                                    disabled={false}
                                    isAutonomo={null}

                                />
                                <FormInputText
                                    name='Pluriactividad.PluriactividadDomicilio'
                                    id='Pluriactividad.PluriactividadDomicilio'
                                    label='Domicilio'
                                    md={6}
                                    xl={6}

                                    disabled={false}
                                />
                                <FormInputText
                                    name='Pluriactividad.PluriactividadNumero'
                                    id='Pluriactividad.PluriactividadNumero'
                                    label='Número'
                                    md={3}
                                    xl={3}
                                    disabled={false}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten numeros enteros'
                                />
                                <FormInputText
                                    name='Pluriactividad.PluriactividadPuerta'
                                    id='Pluriactividad.PluriactividadPuerta'
                                    label='Puerta'
                                    md={3}
                                    xl={3}
                                    disabled={false}

                                    patternMessage='Solo se permiten numeros enteros'
                                />
                                <FormInputText
                                    name='Pluriactividad.PluriactividadPiso'
                                    id='Pluriactividad.PluriactividadPiso'
                                    label='Piso'
                                    md={3}
                                    xl={3}

                                    disabled={false}
                                />
                                <FormInputText
                                    name='Pluriactividad.PluriactividadEscalera'
                                    id='Pluriactividad.PluriactividadEscalera'
                                    label='Esc./Bloque'
                                    md={3}
                                    xl={3}

                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />


                                <div className="col-xl-6 col-md-6">
                                    <Province
                                        errors={errors}
                                        register={register}
                                        idCode={'Pluriactividad.PluriactividadProvincia'}
                                        watchProvinceDescription={watchProvinciaDescPluriactividad}
                                        idDescription={'Pluriactividad.PluriactividadProvinciaDescripcion'}
                                        watchProvinceCode={watchProvinciaPluriactividad}
                                        setValue={setValue}
                                        disabled={false}
                                    />
                                </div>
                                <div className="col-xl-6 col-md-6">
                                    <TestCommunity
                                        errors={errors}
                                        register={register}
                                        setValue={setValue}
                                        watchProvinceCode={watchProvinciaPluriactividad}
                                        watchCommunityCode={watchCommPluriactividad}
                                        watchCommunityDescription={watchCommDescPluriactividad}
                                        idCode={'Pluriactividad.PluriactividadLocalidad'}
                                        idDescription={'Pluriactividad.PluriactividadLocalidadDescripcion'}
                                        filterByProvince={true}
                                        disabled={false}
                                    />
                                </div>


                                <FormInputText
                                    name='Pluriactividad.PluriactividadCodigoPostal'
                                    id='Pluriactividad.PluriactividadCodigoPostal'
                                    label='Codigo Postal'
                                    md={4}
                                    xl={4}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />

                                <FormInputText
                                    name='Pluriactividad.PluriactividadTelefono'
                                    id='Pluriactividad.PluriactividadTelefono'
                                    label='Teléfono'
                                    md={4}
                                    xl={4}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />

                                <FormInputEmail
                                    name='Pluriactividad.PluriactividadCorreoElectronico'
                                    id='Pluriactividad.PluriactividadCorreoElectronico'
                                    label='Correo Electrónico'
                                    md={4}
                                    xl={4}
                                    disabled={false}
                                />

                                <FormInputText
                                    name='Pluriactividad.PluriactividadCIF'
                                    id='Pluriactividad.PluriactividadCIF'
                                    label='CIF de la Empresa'
                                    md={6}
                                    xl={6}

                                    disabled={false}
                                />
                                <FormInputText
                                    name='Pluriactividad.PluriactividadFunciones'
                                    id='Pluriactividad.PluriactividadFunciones'
                                    label='Funciones que desempeña en la Empresa'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />

                                <div className='paragraph mb-3 col-12 mt-3'>Si el autónomo se encuentre en situación de pluriactividad, en el momento del hecho causante de la
                                    prestación por cese de actividad, la prestación por cese será compatible con la percepción de la
                                    remuneración por el trabajo por cuenta ajena que se venía desarrollando, siempre y cuando de la suma de
                                    la retribución mensual media de los últimos cuatro meses inmediatamente anteriores al nacimiento del
                                    derecho y la prestación por cese de actividad, resulte una cantidad media mensual inferior al importe del
                                    salario mínimo interprofesional vigente en el momento del nacimiento del derecho.
                                </div>

                                <FormInputCheckboxTable
                                    title={"Pluriactividad en el momento del hecho causante de la prestación por cese de actividad"}
                                    col={12}
                                    labels={[
                                        "¿Pluriactividad en el Momento?",
                                    ]}
                                    names={[
                                        "Pluriactividad.PluriactividadHechoCausante",
                                    ]}
                                />

                                <div className='my-3'></div>


                                <FormInputCheckboxTable
                                    title={"Promedio mensual de la retribución bruta por cuenta ajena de los últimos cuatro meses anteriores a la fecha de la solicitud"}
                                    col={12}
                                    labels={[
                                        "Marque para especificar el promedio mensual",
                                    ]}
                                    names={[
                                        "Pluriactividad.PluriactividadRetribucionBruta",
                                    ]}
                                />

                                <AccordionDisplay dataUser={dataUser} visibility={watch('Pluriactividad.PluriactividadRetribucionBruta') === true} fields={[]}>

                                    <FormInputText
                                        name='Pluriactividad.PluriactividadPromedioMensual'
                                        id='Pluriactividad.PluriactividadPromedioMensual'
                                        label=''
                                        md={12}
                                        xl={12}
                                        disabled={false}
                                        req={watch('Pluriactividad.PluriactividadRetribucionBruta') === true ? 'Debe especificar el promedio mensual' : null}
                                    />

                                </AccordionDisplay>
                            </FieldsetContainer>



                        </div>
                    </div>
                </AccordionForm>







                <AccordionForm title={'Datos del cese de la actividad'} expandedInit={false} nombreError='CeseActividad' >
                    <div className="row mb-4">
                        <div className="col-xl-12">


                            <FieldsetContainer legend="" disabled={false}>
                                <div className='paragraph mb-3 col-12 mt-1'>I. Prestación ordinaria por cese definitivo o temporal de la actividad (Autónomo que causa baja en la
                                    actividad):
                                </div>
                                <FormInputFecha
                                    name={'CeseActividad.CeseDefinitivoFechaInicioActividad'}
                                    id={'CeseActividad.CeseDefinitivoFechaInicioActividad'}
                                    label={'Fecha de inicio actividad'} placeholder={''} md={6} xl={6} col={12}
                                    disableDate={false}
                                />
                                <FormInputFecha
                                    name={'CeseActividad.CeseDefinitivoFechaCeseActividad'}
                                    id={'CeseActividad.CeseDefinitivoFechaCeseActividad'}
                                    label={'Fecha de Cese actividad'} placeholder={''} md={6} xl={6} col={12}
                                    disableDate={false}
                                />
                                <FormInputRadioGroup
                                    title="Tipo de Cese"
                                    name="CeseActividad.CeseDefinitivoTipoCese"
                                    labels={["Cese definitivo", "Cese temporal"]}
                                    required="Debe seleccionar una opción"
                                    col={12}
                                    modal={['', 'Solo en supuesto de fuerza mayor y violencia de género']}
                                />

                                <AccordionDisplay dataUser={dataUser} visibility={watch('CeseActividad.CeseDefinitivoTipoCese') === '1'} fields={['CeseActividad.CeseDefinitivoFechaReinicioActividad']}>
                                    <FormInputFecha
                                        name={'CeseActividad.CeseDefinitivoFechaReinicioActividad'}
                                        id={'CeseActividad.CeseDefinitivoFechaReinicioActividad'}
                                        label={'Fecha de reinicio actividad'} md={12} xl={12} col={12}
                                        disableDate={false}
                                    />
                                </AccordionDisplay>


                                <div className='paragraph mb-3 col-12 mt-2'>II.  Prestación ordinaria por cese PARCIAL de la actividad (Autónomo que continúa en el desarrollo parcial
                                    de la actividad):
                                </div>
                                <FormInputFecha
                                    name={'CeseActividad.CeseParcialFechaInicioActividad'}
                                    id={'CeseActividad.CeseParcialFechaInicioActividad'}
                                    label={'Fecha de inicio actividad'} md={6} xl={6} col={12}
                                    disableDate={false}
                                />
                                <FormInputFecha
                                    name={'CeseActividad.CeseParcialFechaCeseActividad'}
                                    id={'CeseActividad.CeseParcialFechaCeseActividad'}
                                    label={'Fecha de cese de la actividad'} md={6} xl={6} col={12}
                                    disableDate={false}
                                />
                            </FieldsetContainer>

                            <FieldsetContainer legend="" disabled={false}>
                                <FormInputText
                                    name='CeseActividad.PeriodosCotizadosCeseActividad'
                                    id='CeseActividad.PeriodosCotizadosCeseActividad'
                                    label='Períodos cotizados por cese de actividad'
                                    md={12}
                                    xl={12}
                                    disabled={false}
                                />
                                <FormInputRadioGroup
                                    title="Supuestos Generales aplicables a todos los colectivos, debe acompañar el documento Declaración Jurada que proceda"
                                    name="CeseActividad.SupuestosGenerales"
                                    labels={["Concurrencia de motivos económicos, técnicos, productivos u organizativos", "Fuerza mayor", "Pérdida de la licencia administrativa, no motivada por infracciones penales", "Violencia de género o violencia sexual de la solicitante", "Divorcio o separación matrimonial (cuando el solicitante ejerciera funciones de ayuda familiar en el negocio)."]}
                                    col={12}

                                />
                                <AccordionDisplay dataUser={dataUser} visibility={watch('CeseActividad.SupuestosGenerales') === '0'} fields={[
                                    "CeseActividad.PerdidasAnyo",
                                    "CeseActividad.EjecucionesJudiciales",
                                    "CeseActividad.DeclaracionJudicial",
                                    "CeseActividad.ReduccionJornada",
                                    "CeseActividad.MantenerDeudas",
                                    "CeseActividad.AutonomosAyudaFamiliar"]}>
                                    <FormInputCheckboxTable
                                        title={""}
                                        col={12}
                                        required={watch('CeseActividad.SupuestosGenerales') === '0' ? 'Debe seleccionar al menos una opcion sobre motivos económicos, técnicos, productivos u organizativos' : null}
                                        labels={[
                                            "Pérdidas en un año completo superiores al 10%",
                                            "Ejecuciones judiciales o administrativas tendentes al cobro de las deudas",
                                            "Declaración judicial de concurso que impida continuar la actividad",
                                            "Reducción del 60% de la jornada de la totalidad de los trabajadores",
                                            "Mantener deudas exigibles con acreedores cuyo importe supere el 150%",
                                            "Autónomo/a que viniera realizando funciones de ayuda familiar"
                                        ]}
                                        names={[
                                            "CeseActividad.PerdidasAnyo",
                                            "CeseActividad.EjecucionesJudiciales",
                                            "CeseActividad.DeclaracionJudicial",
                                            "CeseActividad.ReduccionJornada",
                                            "CeseActividad.MantenerDeudas",
                                            "CeseActividad.AutonomosAyudaFamiliar"
                                        ]}
                                        modal={[
                                            "Pérdidas en un año completo superiores al 10% de los ingresos, excluido el primer año de actividad.",
                                            "Ejecuciones judiciales o administrativas tendentes al cobro de las deudas reconocidas por los órganos ejecutivos, que comporten al menos el 30% de los ingresos del ejercicio económico inmediatamente anterior.",
                                            null,
                                            "Reducción del 60% de la jornada de la totalidad de los trabajadores en situación de alta en la empresa o suspensión temporal de los contratos de trabajo de al menos del 60% del número de trabajadores en situación de alta en la empresa. (art. 331 1 a) 4º)",
                                            "Mantener deudas exigibles con acreedores cuyo importe supere el 150% de los ingresos ordinarios o ventas durante los dos trimestres fiscales previos a la solicitud (art. 331 1 a) 5º).",
                                            "Autónomo/a que viniera realizando funciones de ayuda familiar por: muerte, jubilación o incapacidad del titular del negocio."
                                        ]}

                                    />
                                </AccordionDisplay>
                                <AccordionDisplay dataUser={dataUser} visibility={watch('CeseActividad.SupuestosGenerales') === '1'} fields={[
                                    "CeseActividad.FuerzaMayorDefinitivo",
                                    "CeseActividad.FuerzaMayorTotal",
                                    "CeseActividad.FuerzaMayorParcial",]}>
                                    <FormInputCheckboxTable
                                        title={""}
                                        col={12}
                                        required={watch('CeseActividad.SupuestosGenerales') === '1' ? 'Debe seleccionar al menos una opcion sobre fuerza mayor' : null}
                                        labels={[
                                            "Definitivo",
                                            "Temporal Total",
                                            "Temporal Parcial",
                                        ]}
                                        names={[
                                            "CeseActividad.FuerzaMayorDefinitivo",
                                            "CeseActividad.FuerzaMayorTotal",
                                            "CeseActividad.FuerzaMayorParcial",
                                        ]}
                                        modal={[
                                            null,
                                            null,
                                            "Mediante la declaración de emergencia adoptada por la autoridad pública competente."
                                        ]}
                                    />
                                </AccordionDisplay>

                                <div className='m-3'></div>
                                <FormInputRadioGroup
                                    title="Otros motivos adicionales para el caso de Trabajador/a Autónomo/a Económicamente Dependiente (TRADE):"
                                    name="CeseActividad.OtrosMotivosCeseTRADE"
                                    labels={[
                                        "Terminación de la duración contractual, obra o servicio",
                                        "Incumplimiento contractual grave del cliente",
                                        "Rescisión de la relación contractual del cliente por causa justificada",
                                        "Rescisión de la relación contractual del cliente por causa injustificada",
                                        "Por muerte, incapacidad o jubilación del cliente"
                                    ]}
                                    col={12}
                                />
                                <div className='m-3'></div>
                                <FormInputRadioGroup
                                    title="Otros motivos adicionales para el caso de socios/as trabajadores de cooperativas de trabajo asociado:"
                                    name="CeseActividad.OtrosMotivosCeseCooperativa"
                                    labels={[
                                        "Cese en la actividad desarrollada en la cooperativa por expulsión improcedente",
                                        "Cese en la actividad desarrollada en la cooperativa por finalización del período al que se limitó el vínculo societario de duración determinada",
                                        "Cese en la prestación de trabajo durante el período de prueba por decisión unilateral del consejo rector",
                                    ]}
                                    col={12}
                                />
                                <div className='m-3'></div>
                                <FormInputRadioGroup
                                    title="Otros motivos adicionales para el caso de trabajadores por cuenta propia agrarios:"
                                    name="CeseActividad.OtrosMotivosCeseAgrarios"
                                    labels={[
                                        "Cese temporal cuando por fuerza mayor se realice un cambio de cultivo o de actividad ganadera",
                                        "Cese temporal cuando por fuerza mayor se produzca daño en las explotaciones agrarias o ganaderas",
                                        "Cese temporal durante el tiempo de erradicación de las enfermedades en explotaciones ganaderas"
                                    ]}
                                    col={12}
                                />
                                <div className='m-3'></div>
                                <FormInputRadioGroup
                                    title="Aplicación del art. 305.2 b) LGSS para sociedades mercantiles:"
                                    name="CeseActividad.Art305Sociedad"
                                    labels={[
                                        "Pérdidas superiores al 10% de los ingresos",
                                        "Disminución del patrimonio neto por debajo de 2/3 del capital social"
                                    ]}
                                    modal={[
                                        "Pérdidas derivadas del desarrollo de la actividad de la sociedad en un año completo superiores al 10% de los ingresos, excluido el primer año de actividad.",
                                        "Disminución del patrimonio neto de la sociedad por debajo de las 2/3 partes de la cifra del capital social."
                                    ]}
                                    col={12}
                                />





                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>


                <AccordionForm title={'Datos Bancarios'} expandedInit={false} nombreError='DatosBancarios' >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer legend="Datos Bancarios" disabled={false}>

                                <FormInputCuentaBancaria
                                    id='DatosBancarios.SolicitanteIBAN'
                                    name='DatosBancarios.SolicitanteIBAN'
                                    xl={12}
                                    md={12}
                                    placeholder=''
                                    req='Falta el Número de Cuenta Bancaria' />
                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>

                <AccordionForm title={'Datos de la asesoría'} expandedInit={false} nombreError='DatosAsesoria'  >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer legend="Datos Asesoria" disabled={false}>

                                <FormInputText
                                    name='DatosAsesoria.AsesoriaNombre'
                                    id='DatosAsesoria.AsesoriaNombre'
                                    label='Nombre de la Asesoria'
                                    md={12}
                                    xl={12}
                                    disabled={false}
                                />
                                <FormInputText
                                    name='DatosAsesoria.AsesoriaCIF'
                                    id='DatosAsesoria.AsesoriaCIF'
                                    label='CIF de la asesoría'
                                    md={6}
                                    xl={6}

                                    disabled={false}
                                />
                                <FormInputText
                                    name='DatosAsesoria.AsesoriaNumeroRed'
                                    id='DatosAsesoria.AsesoriaNumeroRed'
                                    label='Nº RED'
                                    md={6}
                                    xl={6}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />
                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>

                <AccordionForm
                    title={'Documentación'}
                    expandedInit={false}
                    nombreError='Documentacion'
                    totalSize={totalSize}
                    maxSize={MAX_SIZE_MB}
                >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FormArrayArchivosReducidos
                                name={'Documentacion'}
                                setTotalSize={setTotalSize}
                            />
                        </div>
                    </div>
                </AccordionForm>





                {/* ////////////// FINAL FORMULARIO ////////////// */}

                <FormInfoSolicitudesDependientes data={dataUser} />

                {/* ////////////// BLOQUEO DEL ENVIO DEL FORMULARIO //////////// */}
                <FormBotonSubmit
                    disableSubmit={bloquearEnvio}
                    onSubmit={handleSubmit(onSubmit)}
                    successCreate={successCreateFormularioPECATA}
                    successUpdate={successUpdateFormularioPECATAById}
                    errorCreate={errorCreateFormularioPECATA}
                    errorUpdate={errorUpdateFormularioPECATAById}
                    datosAPI={datosAPI}
                    info={info}
                    initExpand={!info}
                    totalSizeDocs={totalSize}
                    MaxSizeMB={MAX_SIZE_MB}
                    label='Declara bajo su responsabilidad que son ciertos los datos que se consignan en la presente declaración y que, al día de
                        la fecha, los datos declarados siguen siendo vigentes y asimismo quedo enterado de la obligación de comunicar a la 
                        Mutua cualquier variación de los datos en ella expresados, que reclamación de la prestación que hubiera dado lugar.'
                >
                    <div>
                        <p><strong>La Mutua le informa:</strong></p>

                        <ol >
                            <li className='mb-2'>
                                En cualquier momento usted podrá dirigirse a nuestras oficinas y/o consultar nuestra página web.
                                Estamos a su plena disposición para asesorarle e informarle.
                            </li>

                            <li className='mb-2'>
                                Este documento, junto con el resto de los que integran el expediente tramitado por Mutua,
                                podrá ser presentado por la Mutua ante la Inspección de Trabajo y la Seguridad Social cuando
                                se detecten contradicciones en las declaraciones y certificaciones, de acuerdo con lo dispuesto
                                en la normativa vigente.
                            </li>

                            <li className='mb-2'>
                                De no estar usted de acuerdo con las decisiones de Mutua, podrá efectuar reclamación previa
                                ante ese órgano gestor antes de acudir al órgano jurisdiccional del orden social competente.
                            </li>

                            <li className='mb-2'>
                                Son obligaciones de los trabajadores autónomos, así como de los solicitantes y beneficiarios
                                de la protección por cese de actividad:
                                <ul >
                                    <li className='mt-2'>
                                        <strong>a)</strong> Solicitar a la misma Mutua de Accidentes de Trabajo y Enfermedades Profesionales de la
                                        Seguridad Social con la que tengan concertadas contingencias profesionales la cobertura
                                        de la protección por cese de actividad.
                                    </li>
                                    <li className='mt-2'>
                                        <strong>b)</strong> Cotizar por la aportación correspondiente a la protección por cese de actividad.
                                    </li>
                                    <li>
                                        <strong>c)</strong> Proporcionar la documentación e información necesarias a los efectos del reconocimiento,
                                        suspensión, extinción o reanudación de la prestación.
                                    </li>
                                    <li className='mt-2'>
                                        <strong>d)</strong> Si es usted TRADE que ha finalizado su relación con el cliente principal, para poder tener derecho al disfrute de la
                                        prestación deberá hacer causado baja efectiva en el Régimen Especial antes de comenzar a recibir la prestación
                                        económica. En el resto de los supuestos, será suficiente haber solicitado la baja en el Régimen Especial con
                                        anterioridad a la fecha de la solicitud de la prestación.
                                    </li>
                                    <li className='mt-2'>
                                        <strong>e)</strong> Solicitar la baja en la prestación por cese de actividad cuando se produzcan situaciones de suspensión o extinción
                                        del derecho o se dejen de reunir los requisitos exigidos para su percepción, en el momento en que se producen
                                        dichas situaciones.
                                    </li>
                                    <li className='mt-2'>
                                        <strong>f)</strong> No trabajar por cuenta propia o ajena durante la percepción de la prestación.
                                    </li>
                                    <li className='mt-2'>
                                        <strong>g)</strong> Reintegrar las prestaciones indebidamente percibidas.
                                    </li>
                                    <li className='mt-2'>
                                        <strong>h)</strong> Comparecer a requerimiento del órgano gestor y estar a disposición del mismo, del Servicio
                                        Público de Empleo o del Instituto Social de la Marina de la correspondiente Comunidad
                                        Autónoma para realizar las actividades formativas y de orientación profesional convocadas.
                                    </li>
                                    <li className='mt-2'>
                                        <strong>i)</strong> Participar en acciones específicas de motivación, información, orientación, formación, reconversión o inserción
                                        profesional para incrementar su ocupabilidad, que se determinen por el órgano gestor, por Servicio Público de
                                        Empleo de la correspondiente Comunidad Autónoma, o por el Instituto Social de la Marina, en su caso.
                                    </li>
                                </ul>
                            </li>

                            <li>
                                La prestación económica por cese en la actividad se encuentra regulada en el Título V “Protección por cese de actividad”
                                de RDL 8/2015 de 30 de octubre por el que se aprueba el TRLGSS.
                            </li>
                        </ol>
                    </div>

                </FormBotonSubmit>


                <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>
                    Esta solicitud va a ser tramitada por medios informáticos. Los datos personales que figuran en ella serán incorporados a un fichero de base de datos para el cálculo y control de la prestación económica
                    que se le reconozca, y permanecerán bajo custodia de esta Entidad. En cualquier momento puede ejercitar su derecho de acceso, rectificación, cancelación y oposición sobre los datos incorporados al
                    fichero ( art. 5 de la ley 15/1999 de 13 diciembre de Protección de datos de carácter personal, BOE del día 14)
                </p>

                <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>
                    En cumplimiento de lo establecido en la normativa sobre de Protección de Datos de Carácter Personal, Solimat Mutua Colaboradora con la Seguridad Social nº 72 le informa que sus datos de carácter
                    personal serán objeto de tratamiento, con la finalidad del mantenimiento y cumplimiento de la relación. La base jurídica que legitima el tratamiento de sus datos es el
                    cumplimiento de una obligación legal. Sus datos serán conservados de forma indefinida en nuestra entidad para atender a las posibles responsabilidades derivadas del tratamiento. Usted
                    podrá revocar el consentimiento prestado, así como ejercitar sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, o portabilidad, en su caso, remitiendo un
                    escrito a la siguiente dirección: Solimat, Mutua Colaboradora con la Seguridad Social nº 72, C/ Berna, 1, 45003, Toledo, adjuntando su NIF. Si considera que sus derechos no han sido
                    debidamente atendidos, puede contactar con nuestro delegado de protección de datos lopd@solimat.com o interponer una reclamación frente a la Agencia Española de Protección de Datos.
                </p>



            </div>
        </FormProvider>
    )
}

export default FormularioPECATA
